import { createSelector } from 'reselect'

import payloadTypes from 'helpers/enums/interactiveVideo/payloadTypes'

const getActivities = state => state.interactiveVideo.activities
const getActivityUid = (state, activityUid) => activityUid

const activityDataSelector = createSelector(
	[ getActivities, getActivityUid ],
	(activities, activityUid) => {
		const currentActivity = activities.find(activity => activity[payloadTypes[activity.type]].uid === activityUid)
		return {
			type: currentActivity.type,
			payload: currentActivity[payloadTypes[currentActivity.type]],
		}
	}
)

export default activityDataSelector
